  /* eslint-disable no-undef */
  import store from '@/store';

  import {
    GA_CATEGORY,
    GA_EVENTS_ACTION_MAP,
    DEFAULT,
  } from '@/forms/constants/ga';

  const getAction = (actions, key) => {
    const currentAction = actions.find(ac => ac.key === key);

    if (!currentAction) {
      return actions.find(ac => ac.key === DEFAULT).actionName;
    }

    return currentAction.actionName;
  };

  const sendGAEvent = (stepName, actionKey = null) => {
    const category = GA_CATEGORY;
    const label = store.state.formData.product;

    const gaCase = GA_EVENTS_ACTION_MAP.find(currentCase => currentCase.stepName === stepName);

    if (!gaCase) {
      return false;
    }

    const { name, actions } = gaCase;

    const action = getAction(actions, actionKey);

    if (!process.env.VUE_APP_GA_MEASUREMENT_ID) {
      return console.log({
        category,
        action,
        label,
        name,
      });
    }

    return ga('send', 'event', category, action, label, name);
  };

  export default sendGAEvent;
